{
  "content": [
    {
      "id": "club-real-madrid",
      "name": "Real Madrid CF",
      "code": "RMA",
      "city": "Madrid",
      "stadiumName": "Santiago Bernabéu",
      "capacity": 84744
    },
    {
      "id": "club-fc-barcelona",
      "name": "FC Barcelona",
      "code": "FCB",
      "city": "Barcelona",
      "stadiumName": "Spotify Camp Nou",
      "capacity": 99354
    },
    {
      "id": "club-atletico",
      "name": "Atlético de Madrid",
      "code": "ATM",
      "city": "Madrid",
      "stadiumName": "Cívitas Metropolitano",
      "capacity": 70460
    },
    {
      "id": "club-athletic",
      "name": "Athletic Club",
      "code": "ATH",
      "city": "Bilbao",
      "stadiumName": "San Mamés",
      "capacity": 53289
    },
    {
      "id": "club-real-sociedad",
      "name": "Real Sociedad",
      "code": "RSO",
      "city": "San Sebastián",
      "stadiumName": "Reale Arena",
      "capacity": 39500
    },
    {
      "id": "club-betis",
      "name": "Real Betis",
      "code": "BET",
      "city": "Sevilla",
      "stadiumName": "Benito Villamarín",
      "capacity": 60721
    },
    {
      "id": "club-sevilla",
      "name": "Sevilla FC",
      "code": "SEV",
      "city": "Sevilla",
      "stadiumName": "Ramón Sánchez-Pizjuán",
      "capacity": 43883
    },
    {
      "id": "club-villarreal",
      "name": "Villarreal CF",
      "code": "VIL",
      "city": "Villarreal",
      "stadiumName": "Estadio de la Cerámica",
      "capacity": 23500
    },
    {
      "id": "club-valencia",
      "name": "Valencia CF",
      "code": "VAL",
      "city": "Valencia",
      "stadiumName": "Mestalla",
      "capacity": 49430
    },
    {
      "id": "club-celta",
      "name": "RC Celta",
      "code": "CEL",
      "city": "Vigo",
      "stadiumName": "Abanca-Balaídos",
      "capacity": 24791
    }
  ],
  "totalElements": 10,
  "totalPages": 1
}
